<script setup lang="ts">
import type { ICellRendererParams } from 'ag-grid-enterprise';
import type { CrewBriefingTemplate } from '@/api/client/models/index.ts';

type ActionParams = ICellRendererParams<CrewBriefingTemplate> & {
  onDelete: (fileName: string) => void;
  onDownload: (fileName: string) => void;
};

const props = defineProps<{
  params: ActionParams;
}>();

function withFileName(action: (fileName: string) => void): void {
  const fileName = props.params.data?.fileName;
  if (fileName) {
    action(fileName);
  }
}
</script>

<template>
  <span class="flex h-full items-center gap-3">
    <button
      type="button"
      class="ag-grid-button material-icons cursor-pointer text-red"
      title="Download template"
      aria-label="Download template"
      @click.stop="withFileName(params.onDownload)"
    >
      download
    </button>
    <button
      type="button"
      class="ag-grid-button material-icons cursor-pointer text-red"
      title="Delete template"
      aria-label="Delete template"
      @click.stop="withFileName(params.onDelete)"
    >
      delete
    </button>
  </span>
</template>
